import React, { useState, useEffect, useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl';
import withNavigate from '../../components/common/withNavigate'
import './Registration.css'
import CheckEmailModal from './CheckEmailModal'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import ModalPasswordInput from '../../components/Modals/ModalInputs/ModalPasswordInput'
import commonFunctions from '../../utils/commonFunctions'
import useValidateFields from '../../components/common/useValidateFields';
import API from '../../utils/API'

function RegistrationModal(props) {
  const intl = useIntl();
  const translation = (id) => intl.formatMessage({ id })
  const {
    loadTable,
    dataMap,
    closeModal,
    success, setSuccess,
    isModal = false,
    selectedAccount, setSelectedAccount,
    setResetAccountModalRef,
  } = props;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    address: '',
    companyName: '',
    companyPhone: '',
    password: '',
    passwordConfirm: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [modalError, setModalError] = useState('');

  const {
    firstNameValid,
    lastNameValid,
    phoneValid,
    emailValid,
    addressValid,
    companyNameValid,
    companyPhoneValid,
    passwordValid,
    passwordConfirmValid
  } = useValidateFields(
    {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phone: formData.phone,
      email: formData.email,
      address: formData.address,
      companyName: formData.companyName,
      companyPhone: formData.companyPhone,
      password: formData.password,
      passwordConfirm: formData.passwordConfirm
    }, selectedAccount
  );

  useEffect(() => {
    console.log('selectedAccount changed')
    if (selectedAccount) {
      setFormData({
        firstName: selectedAccount.firstName,
        lastName: selectedAccount.lastName,
        phone: selectedAccount.phone,
        email: selectedAccount.email,
        address: selectedAccount.address,
        companyName: selectedAccount.companyName,
        companyPhone: selectedAccount.companyPhone,
        password: '',
        passwordConfirm: ''
      });
    }
  }, [selectedAccount])

  useEffect(() => {
    setResetAccountModalRef(resetModal);
  }, [setResetAccountModalRef]);

  /**
   * Reset fields of user modal
   */
  function resetModal() {
    console.log('reset modal')
    setSelectedAccount(null);
    setSubmitted(false);
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      address: '',
      companyName: '',
      companyPhone: '',
      password: '',
      passwordConfirm: ''
    });
  }
  
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);
  
  const handlePhoneChange = useCallback((value) => {
    setFormData((prevData) => ({
      ...prevData,
      phone: value,
    }));
  }, []);
  
  const handleCompanyPhoneChange = useCallback((value) => {
    setFormData((prevData) => ({
      ...prevData,
      companyPhone: value,
    }));
  }, []);  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    // Log each field's value and validation status
    console.log('First name:', formData.firstName, 'Valid:', firstNameValid);
    console.log('Last name:', formData.lastName, 'Valid:', lastNameValid);
    console.log('Phone:', formData.phone, 'Valid:', phoneValid);
    console.log('Email:', formData.email, 'Valid:', emailValid);
    console.log('Company name:', formData.companyName, 'Valid:', companyNameValid);
    console.log('Company phone:', formData.companyPhone, 'Valid:', companyPhoneValid);
    console.log('Address:', formData.address, 'Valid:', addressValid);
    console.log('Password:', formData.password, 'Valid:', passwordValid);
    console.log('Confirm Password:', formData.passwordConfirm, 'Valid:', passwordConfirmValid);

    if (
      !firstNameValid &&
      !lastNameValid &&
      !phoneValid &&
      !companyNameValid &&
      // !companyPhoneValid &&
      !addressValid &&
      !passwordValid &&
      !passwordConfirmValid
    ) {
      console.log('calling handleEditAccount')
      handleEditAccount(e);
    } else {
      console.log('validation failed')
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
      setSuccess(null);
    }
  };

  /**
   * Handle edit button click on account in a row
   */
  function handleEditAccount(e) {
    e.preventDefault();
    console.log('handle edit account')
    console.log(selectedAccount);
    const userData = {
      id: selectedAccount.userId,
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim(),
      phone: formData.phone,
      password:formData.password.trim()
    }

    // Convert companyPhone to an empty string if it's null or undefined
    const normalizedCompanyPhone = formData.companyPhone == null ? '' : formData.companyPhone;

    const accountData = {
      id: selectedAccount.id,
      name: formData.companyName.trim(),
      phone: normalizedCompanyPhone,
      address: formData.address.trim()
    };

    // console.log('userData:', userData)
    // console.log('accountData:', accountData)
    API.editUser(userData)
      .then((res) => {
        console.log('user edited successfully', res)
        // After the user is edited successfully, make the API call to edit the account
        return API.editAccount(accountData);
      })
      .then((accountRes) => {
        console.log("Editing account:", selectedAccount.id, selectedAccount.companyName)
        console.log('account edited successfully', accountRes)
        // Both user and account have been edited successfully
        loadTable(dataMap, false);
        setSuccess(<FormattedMessage id="EDIT_ACCOUNT_SUCCESS" />)
        closeModal('editAccountModal');
        resetModal();
      })
    .catch((error) => {
      // Handle any errors that may occur during the API calls
      console.error('Error:', error);
      console.error('Response:', error.response)
      // Determine which part of the process failed and set an appropriate error message
      if (error.message.includes('editing user')) {
        setModalError(<FormattedMessage id="EDIT_USER_FAILED" />);
      } else if (error.message.includes('editing account')) {
        setModalError(<FormattedMessage id="EDIT_ACCOUNT_FAILED" />);
      } else {
        setModalError(<FormattedMessage id="UNKNOWN_ERROR" />);
      }
    });
  }

  const className = isModal ? 'registration modal-registration' : 'registration';

  return (
    <div className={`${className} container py-5 h-100 w-50`}>
      <form>
        <div className='card'>
          <div className='row mb-2'>
            {isModal && <button type='button' className='btn-close' id='registrationModalClose' data-bs-dismiss='modal' aria-label='Close'></button>}
            <div className='header text-center'>
              <h2><FormattedMessage id="EDIT_ACCOUNT" /></h2>
            </div>
            <div className='col me-2'>
              <div className='form-outline mt-2'>
                <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="FIRST_NAME" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <input
                  id='firstNameInput'
                  onChange={handleChange}
                  value={formData.firstName}
                  name='firstName'
                  className={`form-control rounded-1 ${submitted && (!firstNameValid ? 'is-valid' : 'is-invalid')}`}
                />
                {commonFunctions.InvalidFeedbackString(firstNameValid,"FIRST_NAME")}
              </div>
            </div>
            <div className='col'>
              <div className='form-outline mt-2'>
                <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="LAST_NAME" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <input
                  id='lastNameInput'
                  onChange={handleChange}
                  value={formData.lastName}
                  name='lastName'
                  className={`form-control rounded-1 ${submitted && (!lastNameValid ? 'is-valid' : 'is-invalid')}`}
                />
                {commonFunctions.InvalidFeedbackString(lastNameValid,"LAST_NAME")}
              </div>
            </div>
          </div>
          <div className='row mb-2'>
            <div className='col me-2'>
              <div className='form-outline'>
                <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="EMAIL" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <input
                  id='emailInput'
                  value={formData.email}
                  type='text'
                  name='email'
                  aria-label="readonly input"
                  className='form-control rounded-1 read-only-input'
                  readOnly
                />
              </div>
            </div>
            <div className='col'>
              <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="PHONE" /><FormattedMessage id="SYMBOL_COLON" /></label>
              <PhoneInput
                id='phoneInput'
                onChange={handlePhoneChange}
                name='phone'
                className={`form-control rounded-1 ${submitted && (!phoneValid ? 'is-valid' : 'is-invalid')}`}
                placeholder={translation("ENTER_PHONE_NUMBER")}
                value={formData.phone}
              />
              {commonFunctions.InvalidFeedbackString(phoneValid,"PHONE")}
            </div>
          </div>
          <div className='row mb-2'>
            <div className='col me-2'>
              <div className='form-outline'>
                <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="COMPANY_NAME" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <input
                  id='companyNameInput'
                  onChange={handleChange}
                  value={formData.companyName}
                  name='companyName'
                  className={`form-control rounded-1 ${submitted && (!companyNameValid ? 'is-valid' : 'is-invalid')}`}
                />
                {commonFunctions.InvalidFeedbackString(companyNameValid,"COMPANY_NAME")}
              </div>
            </div>
            <div className='col'>
              <div className='form-outline'>
                <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="COMPANY_PHONE" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <PhoneInput
                  id='companyPhoneInput'
                  onChange={handleCompanyPhoneChange}
                  className={`form-control rounded-1 ${submitted && (!companyPhoneValid ? 'is-valid' : 'is-invalid')}`}
                  placeholder={translation("ENTER_PHONE_NUMBER")}
                  value={formData.companyPhone}
                />
                {commonFunctions.InvalidFeedbackString(companyPhoneValid,"COMPANY_PHONE")}
              </div>
            </div>
          </div>
          <div className='row mb-2'>
            <div className='form-outline'>
              <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="COMPANY_ADDRESS" /><FormattedMessage id="SYMBOL_COLON" /></label>
              <input
                id='addressInput'
                onChange={handleChange}
                value={formData.address}
                name='address'
                className={`form-control rounded-1 ${submitted && (!addressValid ? 'is-valid' : 'is-invalid')}`}
              />
              {commonFunctions.InvalidFeedbackString(addressValid,"COMPANY_ADDRESS")}
            </div>
          </div>
          <div className='row mb-2'>
            <div className='form-outline'>
              <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="PASSWORD" /><FormattedMessage id="SYMBOL_COLON" /></label>
              <ModalPasswordInput
                id='passwordInput'
                onChange={handleChange}
                value={formData.password}
                name='password'
                isSubmitted={submitted}
                // isValid={passwordValid}
                className={`form-control rounded-1 ${submitted && (!passwordValid ? 'is-valid' : 'is-invalid')}`}
              />
              {commonFunctions.InvalidFeedbackString(passwordValid,"PASSWORD","d-block")}
            </div>
          </div>
          <div className='row mb-2'>
            <div className='form-outline'>
              <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="CONFIRM_PASSWORD" /><FormattedMessage id="SYMBOL_COLON" /></label>
              <ModalPasswordInput
                id='passwordConfirmInput'
                onChange={handleChange}
                value={formData.passwordConfirm}
                name='passwordConfirm'
                isSubmitted={submitted}
                isValid={passwordConfirmValid}
                className={`form-control rounded-1 ${submitted && (!passwordConfirmValid ? 'is-valid' : 'is-invalid')}`}
              />
              {commonFunctions.InvalidFeedbackString(passwordConfirmValid,"CONFIRM_PASSWORD","d-block")}
            </div>
          </div>
          {modalError && (
            <div className='modal-error invalid-feedback d-block fw-bold text-center'>
              {modalError}
            </div>
          )}
          <div className='text-center'>
            <button id='confirmEditAccountBtn' type='button' className='mt-2 btn btn-primary btn-block signUpBtn' onClick={handleSubmit}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </form>
      <CheckEmailModal />
    </div>
  )
}

export default withNavigate(RegistrationModal)
